/**
 * Extract the last frame of a completed video as a JPEG URL (for segment chaining).
 * @param {Function} hitAxios
 * @param {string} videoUrl
 */
export async function extractLastFrame(hitAxios, videoUrl) {
  const res = await hitAxios({
    path: "/api/video-studio/extract-last-frame",
    post: true,
    obj: { video_url: videoUrl },
    showLoading: false,
    showSnackbar: false,
    timeout: 120000,
  });

  if (!res?.data?.success) {
    throw new Error(res?.data?.msg || "Could not extract continuity frame.");
  }

  const url = res.data.data?.image_url;
  if (!url) throw new Error("Server did not return a continuity frame URL.");
  return url;
}
